import ThumbRedeem from '../../../assets/img/thumb-redeem-success.png';

import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Input, Button, Form, Modal, Space, Typography, Row } from 'antd';
import RedeemVoucherPostApi from './redeemVoucherPostApi';
import { Link } from 'react-router-dom';
import './redeemVoucher.css';
import { useTranslation } from 'react-i18next';
import GlobalStore from 'stores/globalStore';
import { useGetUserProfileApi } from '../user/useUserApi';
import Loading from 'components/Loading/Loading';

const { Text } = Typography;

const PostList: React.FC = () => {
  const { isLoading, redeemVoucher, value } = RedeemVoucherPostApi();
  const { profileObject, isLoading: profileLoading } = useGetUserProfileApi();
  const [form] = Form.useForm();
  const [isResultRedeem, setIsResultRedeem] = useState(false);
  const { t } = useTranslation();
  const { currentLanguage, entitlements } = GlobalStore.useContainer();
  const isNova = profileObject?.data?.nova_mode;
  React.useEffect(() => {
    value && value.error === false
      ? setIsResultRedeem(true)
      : setIsResultRedeem(false);
  }, [value]);

  const handleCloseModal = () => {
    setIsResultRedeem(false);
  };

  return (
    <div>
      {currentLanguage === 'vi' ? (
        <Helmet>
          <title>Kích hoạt ELSA Speak</title>
          <meta
            name="description"
            content="Kích hoạt mã ELSA Speak Pro, chương trình ELSA Speak Oxford Business Result, gói ELSA for Students. Đăng nhập, đăng ký tài khoản ELSA Speak."
          />
        </Helmet>
      ) : (
        <Helmet>
          <title>ELSA Speak Pro Redeem - ELSA Speak</title>
          <meta
            name="description"
            content="ELSA Speak App redeem code for web PC. ELSA Premium, ELSA Pro Oxford Business Result, ELSA for Students. ELSA Speak account login, signup."
          />
        </Helmet>
      )}
      {!isResultRedeem && (
        <div className="redeem-code">
          <h2>{t('redeem.redeem_code')}</h2>
          {profileLoading ? (
            <Row justify="center">
              <Loading color="#ccc" />
            </Row>
          ) : (
            <>
              <p className="guide">{t('redeem.enter_code')}</p>
              <Form
                wrapperCol={{ span: 12 }}
                labelCol={{ span: 8 }}
                layout="vertical"
                form={form}
                initialValues={{ layout: 'vertical' }}
                onFinish={redeemVoucher}
              >
                <Form.Item
                  label={t('redeem.enter_your_code')}
                  name="code"
                  rules={[
                    {
                      required: true,
                      message: 'Please add code'
                    }
                  ]}
                >
                  <Input style={{ height: '50px' }} />
                </Form.Item>

                <Form.Item className="button-voucher">
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="submit-button submit-button-voucher"
                    loading={isLoading}
                  >
                    {t('redeem.confirm')}
                  </Button>
                </Form.Item>
                <Space direction="vertical" size={10} style={{ marginTop: 20 }}>
                  <Text>
                    Trường hợp bạn đã đăng ký gói ELSA trực tiếp thông qua
                    Google Play/App Store, hãy tắt tính năng{' '}
                    <strong>tự động gia hạn</strong> gói học trên ứng dụng thông
                    qua Google Play/App Store, chờ đến khi gói học cũ hết hạn
                    thì kích hoạt mã gói học mới.
                  </Text>
                </Space>
                {!isNova && (
                  <Space
                    direction="horizontal"
                    size={10}
                    style={{ marginTop: 20 }}
                  >
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.9998 2.664C23.3652 2.664 29.3358 8.63467 29.3358 16C29.3358 23.364 23.3652 29.3333 15.9998 29.3333C8.6345 29.3333 2.6665 23.364 2.6665 16C2.66517 8.63467 8.6345 2.664 15.9998 2.664ZM15.9945 13.664C15.6677 13.6644 15.3525 13.7849 15.1087 14.0024C14.8649 14.2199 14.7094 14.5194 14.6718 14.844L14.6625 14.9987L14.6678 22.3347L14.6758 22.4893C14.7131 22.8145 14.8687 23.1147 15.113 23.3326C15.3573 23.5505 15.6732 23.6709 16.0005 23.6709C16.3278 23.6709 16.6437 23.5505 16.888 23.3326C17.1323 23.1147 17.2879 22.8145 17.3252 22.4893L17.3332 22.3333L17.3278 14.9973L17.3185 14.8413C17.28 14.517 17.1237 14.2181 16.8794 14.0013C16.6351 13.7846 16.3198 13.665 15.9932 13.6653M15.9998 8.66667C15.5573 8.66667 15.1328 8.84247 14.8199 9.15541C14.507 9.46834 14.3312 9.89278 14.3312 10.3353C14.3312 10.7779 14.507 11.2023 14.8199 11.5153C15.1328 11.8282 15.5573 12.004 15.9998 12.004C16.4424 12.004 16.8668 11.8282 17.1798 11.5153C17.4927 11.2023 17.6685 10.7779 17.6685 10.3353C17.6685 9.89278 17.4927 9.46834 17.1798 9.15541C16.8668 8.84247 16.4424 8.66667 15.9998 8.66667Z"
                        fill="#FF0008"
                      />
                    </svg>
                    <Text>
                      {entitlements?.tier?.code === 'free'
                        ? 'Ngoại trừ gói ELSA Pro Trọn Đời, bạn chuẩn bị nâng cấp phiên bản mới nhất của ELSA'
                        : ' Bạn chuẩn bị nâng cấp phiên bản mới nhất của ELSA'}
                    </Text>
                  </Space>
                )}
              </Form>
            </>
          )}
        </div>
      )}

      <Modal
        className="modal-redeem-success"
        visible={isResultRedeem}
        onCancel={handleCloseModal}
        footer={null}
      >
        <figure className="redeem-thumb">
          <img src={ThumbRedeem} alt="Đổi mã code thành công" width={236} />
        </figure>
        <h2 className="modal-title">{t('redeem.change_success')}</h2>
        <p>
          <Link to="/">{t('redeem.back_page')}</Link>
        </p>
      </Modal>
    </div>
  );
};

export default PostList;
